import React from "react";
import { Link } from "react-router-dom";
import { Clock, Calendar, ArrowUpRight, ArrowRight } from "lucide-react";
import { RevealStagger, StaggerItem, Reveal } from "@/components/Reveal";
import { BLOG_POSTS, BLOG_ORDER } from "@/data/blog-posts";

const Articles = () => {
  return (
    <section id="articles" data-testid="articles-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="flex items-end justify-between flex-wrap gap-4 mb-14">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">09 — Latest Articles</p>
            <h2 className="font-heading font-extrabold text-[#0b2c4d] text-4xl md:text-5xl tracking-tight mt-3 leading-tight">
              Insights from the clinic
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="view-all-articles-link"
            className="inline-flex items-center gap-1.5 text-brand font-semibold hover:gap-2.5 transition-all"
          >
            View all articles
            <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>

        <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BLOG_ORDER.slice(0, 4).map((slug, i) => {
            const a = BLOG_POSTS[slug];
            return (
              <StaggerItem key={slug}>
                <Link
                  to={`/blog/${slug}`}
                  data-testid={`article-card-${i}`}
                  className="group h-full glass-card rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:shadow-lg transition-all duration-300 flex flex-col"
                >
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={a.image}
                      alt={a.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0b2c4d]/70 to-transparent" />
                    <span className="absolute top-3 left-3 text-[10px] uppercase tracking-wider text-brand font-bold bg-white px-2.5 py-1 rounded-full">
                      {a.category}
                    </span>
                  </div>
                  <div className="p-6 flex flex-col flex-1">
                    <h3 className="font-heading font-extrabold text-[#0b2c4d] text-lg tracking-tight leading-snug flex-1">
                      {a.title}
                    </h3>
                    <div className="mt-4 flex items-center gap-4 text-slate-400 text-xs">
                      <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {a.minutes}</span>
                      <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {a.date}</span>
                    </div>
                    <span
                      data-testid={`article-read-${i}`}
                      className="mt-4 inline-flex items-center gap-1 text-sm text-brand font-semibold self-start"
                    >
                      Read Article
                      <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </StaggerItem>
            );
          })}
        </RevealStagger>
      </div>
    </section>
  );
};

export default Articles;
